module.exports = __webpack_public_path__ + "static/media/CSK-horiz-desktop-default@2x.1a684314.png";